import { render, staticRenderFns } from "./brandSelect.vue?vue&type=template&id=f4e4b392&scoped=true"
import script from "./brandSelect.vue?vue&type=script&lang=js"
export * from "./brandSelect.vue?vue&type=script&lang=js"
import style0 from "./brandSelect.vue?vue&type=style&index=0&id=f4e4b392&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e4b392",
  null
  
)

export default component.exports